import type { CharacterGender } from "@/shared/types/character"

export function getBringToLifeLabel(gender?: CharacterGender | "" | null): string {
  if (gender === "male") return "Bring him to life"
  if (gender === "trans") return "Bring them to life"
  return "Bring her to life"
}
